import * as React from 'react';
import { Component } from 'react';
import { Field, Form, getFormValues, reduxForm } from 'redux-form';
import { connect } from 'react-redux';
import { __ } from '../../core/utils';
import { subscribe } from 'react-contextual';
import Localization from '../../helpers/Localization';
import { enableAutosave } from '../../redux/actions/general/autosave';
import { withRouter } from 'react-router';
import Input from '../../components/Input';
import Select from '../../components/Select';
import { listPossibleBenefitPeriods } from '../../redux/actions/table/company_benefits';

const mapStateToProps = (state) => {
  return {
    values: getFormValues('company_benefits.details')(state),
  };
};

@reduxForm({
  form: 'company_benefits.details',
  enableReinitialize: true,
})
@subscribe(Localization, 'localization')
@connect(mapStateToProps)
@withRouter
class EditCompanyBenefitForm extends Component {
  constructor(props) {
    super(props);

    this.state = {
      possible_periods: [],
    };

    //this._handleSubmit = this._handleSubmit.bind(this);
  }

  UNSAFE_componentWillReceiveProps() {
    enableAutosave(this.props.form);
  }

  componentDidMount() {
    listPossibleBenefitPeriods().then(({ response }) => {
      this.setState({
        possible_periods: _.map(response?.data, (period) => ({
          value: period,
          label: period,
        })),
      });
    });
  }

  render() {
    return (
      <Form onSubmit={this.props.handleSubmit}>
        <Field
          name='name'
          component={Input}
          label={__('edit-company-benefits-form.name')}
        />
        <Field
          name='period'
          component={Select}
          label={__('edit-company-benefits-form.period')}
          options={this.state.possible_periods}
          searchable={true}
        />
      </Form>
    );
  }
}

export default EditCompanyBenefitForm;
